// Achievement icon URLs are stored prefix-stripped in the backend blob (every
// icon shares this exact CDN prefix — verified across the whole schema). The
// client re-prepends it. A stored value that's already absolute (the rare
// non-conforming icon kept whole) is used as-is.
export const ACHIEVEMENT_ICON_PREFIX = 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images'

export function achievementIconUrl(suffix) {
  const s = String(suffix || '')
  if (!s) return ''
  return s.startsWith('http') ? s : ACHIEVEMENT_ICON_PREFIX + s
}
